import {FrameUIEntity, ScenarioModel, ScenarioTriggerModel, STPUIEntity} from '../control/state';
import {UserRole, MediaModel, InputModel} from '../../types/control';

export type ScenarioScreenState = {
    visible: boolean;
    selectedScenario: ScenarioModel;
};

export type ScenarioTriggerScreenState = {
    visible: boolean;
    selectedTrigger: ScenarioTriggerModel;
};

export type ScenarioTriggerControlScreenState<T, U> = {
    selectedTrigger: InputModel;
    selectedUIEntity: T | U;
};

export type MediaScreenState = {
    visible: boolean;
    selectedMedia: MediaModel;
    editMode?: boolean;
};

export type STPUIMediaScreen = {
    visible: boolean;
    selectedMedia: STPUIEntity;
};

export type ScenarioPopupScreenState = {
    visible: boolean;
    selectedScenario: ScenarioModel;
};

export type ScenarioFooterPopupScreenState = {
    visible: boolean;
    selectedScenario: ScenarioModel;
};

export type ScenarioTriggerPopupScreenState = {
    visible: boolean;
    selectedTrigger: ScenarioTriggerModel;
};

export type PopupState = {
    visible: boolean;
    message: string;
    type: 'info' | 'question' | 'success' | 'failure' | 'loading';
    icon?: string;
    callback?: (isApproved: boolean) => void;
    closable: boolean;
    positive_button: {
        text: string;
        timed: boolean;
    }
    showCancel?: boolean;
};

export type PopupAlarmPasswordState = {
    visible: boolean
    callback?: (isApproved: boolean) => void
    closable: boolean
    positive_button: {
        text: string
        timed: boolean
    }
    showCancel?: boolean
}

export type MediaFileTag = 'vertical' | 'horizontal';

export type MediaFileModel = {
    id: string;
    url: string;
    type: 'background',
    registered_by_system: boolean;
    tags: MediaFileTag[];
};

export type ThemeModel = "default" | "rounded";

export type BackButtonModel = {
    to: string;
    is_open: boolean;
};

export type ScenarioSettingModel = {
    visible: boolean;
};

export type GroupSettingModel = {
    visible: boolean;
    is_open?: boolean;
};

export type DateTimeModel = {
    date: string
    time: string
    day: number
}

export type UIState = {
    busy: boolean;
    busyCount: number;
    role: UserRole;
    alarmSettingUp: boolean;
    theme: "default" | "rounded",
    scenarioScreen: ScenarioScreenState;
    triggerScreen: ScenarioTriggerScreenState;
    triggerControlScreen: ScenarioTriggerControlScreenState<STPUIEntity, FrameUIEntity>;
    mediaScreen: MediaScreenState;
    stpUIMediaScreen: STPUIMediaScreen;
    scenarioPopupScreen: ScenarioPopupScreenState;
    scenarioFooterPopupScreen: ScenarioFooterPopupScreenState;
    triggerPopupScreen: ScenarioTriggerPopupScreenState;
    popupState: PopupState;
    popupAlarmPasswordState: PopupAlarmPasswordState;
    mediaFileList: MediaFileModel[];
    applicationLoaded: boolean;
    selectedBackground: string;
    backButton: BackButtonModel;
    scenarioSetting: ScenarioSettingModel;
    groupSetting: GroupSettingModel;
    passwordTimeoutSycle: boolean
    dateTime: DateTimeModel
};

export const initialUIState: UIState = {
    busy: false,
    busyCount: 0,
    role: null,
    alarmSettingUp: false,
    theme: "default",
    scenarioScreen: {
        visible: false,
        selectedScenario: null,
    },
    triggerScreen: {
        visible: false,
        selectedTrigger: null,
    },
    scenarioPopupScreen: {
        visible: false,
        selectedScenario: null,
    },
    scenarioFooterPopupScreen: {
        visible: false,
        selectedScenario: null,
    },
    triggerPopupScreen: {
        visible: false,
        selectedTrigger: null,
    },
    mediaScreen: {
        visible: false,
        selectedMedia: null,
    },
    stpUIMediaScreen: {
        visible: false,
        selectedMedia: null,
    },
    popupState: {
        visible: false,
        type: 'info',
        message: '',
        closable: true,
        positive_button: {
            text: 'Evet',
            timed: false,
        },
        showCancel: false,
    },
    popupAlarmPasswordState:{
        visible: false,
        closable: true,
        positive_button: {
            text: 'Evet',
            timed: false,
        },
        showCancel: false,
    },
    triggerControlScreen: {
        selectedTrigger: null,
        selectedUIEntity: null,
    },
    mediaFileList: [],
    applicationLoaded: false,
    selectedBackground: '',
    backButton: {
        to: '/',
        is_open: false,
    },
    scenarioSetting: {
        visible: false,
    },
    groupSetting: {
        visible: false,
    },
    passwordTimeoutSycle: false,
    dateTime: {
        date: '--.--.--',
        time: '--:--',
        day: 0,
    }
};
